import {useContext, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import Router from '@src/router/Router'
import {AbilityContext} from '@src/utility/context/Can'
import {_getAppSettings, _getMaintenanceMode} from "@store/actions/app"
import LogoSpinner from '@src/components/LogoSpinner'
import MainMode from '@src/components/MainMode'
import {_autoLogin} from '@authModule'

const App = () => {
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)
    const [ready, setReady] = useState(false)
    const maintenance = useSelector(state => state.app.maintenance)

    useEffect(() => {
        _getMaintenanceMode((data) => {
            console.log(data) 
            // setMaintenanceMode(data.maintenanceMode)
        })
       if (maintenance === false) {
        dispatch(
            _getAppSettings(
                () => {
                  _autoLogin(dispatch, ability, () => setReady(true))
                },
                ability
            )
        )
       } 
    }, [dispatch])

    return (
        maintenance ? <MainMode/> :  !ready ? <LogoSpinner/> : <Router/>
    )
}

export default App
